import { usePanelHistoryTop } from 'weblite-router'
import { WappPanel } from '$logic/wapp-panels'

export function useCurrentWappMeta() {
  usePanelHistoryTop('wapp')

  // TODO: Optimize if necessary
  return WappPanel.getTopWappMeta()
}
